import { render, staticRenderFns } from "./UploadArea.vue?vue&type=template&id=7da60c5c&"
import script from "./UploadArea.vue?vue&type=script&lang=js&"
export * from "./UploadArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports